import React, { useState, useRef, useEffect } from "react";
import SortByIcon from "../../../icons/SortByIcon";

function SortBy({ textSort, className, items, onSortChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState(textSort);
  const dropdownRef = useRef(null);

  const toggleList = () => {
    setIsOpen((prev) => !prev);
  };

  const handleChange = (item) => {
    setSelectedSort(item);
    setIsOpen(false);
    if (onSortChange) {
      onSortChange(item);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`sort flex flex-row items-center space-x-2 relative ${className}`}
    >
      <div
        onClick={toggleList}
        className="flex flex-row items-center space-x-2 cursor-pointer mobile:ml-0 desktop:ml-6"
      >
        <SortByIcon />
        <p className="text-dark4 text-bodyMR whitespace-nowrap">{selectedSort}</p>
      </div>

      {isOpen && (
        <ul className="bg-white shadow-shadow5 rounded-lg overflow-hidden w-[160px] absolute top-[30px] right-0 z-30">
          {items?.map((item, index) => (
            <li
              key={index}
              className="text-bodyMR text-dark4 hover:bg-primary hover:text-white px-[16px] py-[7px] text-left cursor-pointer"
              onClick={() => handleChange(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SortBy;
